import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { FileText, Database, Shield } from 'lucide-react';

const TechStackCard: React.FC = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Технический стек</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div>
            <h4 className="font-semibold mb-2 flex items-center">
              <FileText className="mr-2 h-4 w-4" />
              Frontend
            </h4>
            <ul className="text-sm space-y-1 text-gray-600">
              <li>• React 18 + TypeScript</li>
              <li>• Vite для сборки</li>
              <li>• shadcn/ui компоненты</li>
              <li>• Tailwind CSS</li>
              <li>• React Router</li>
              <li>• TanStack Query</li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-2 flex items-center">
              <Database className="mr-2 h-4 w-4" />
              Backend
            </h4>
            <ul className="text-sm space-y-1 text-gray-600">
              <li>• Supabase (PostgreSQL)</li>
              <li>• Edge Functions (Deno)</li>
              <li>• Row Level Security</li>
              <li>• Real-time subscriptions</li>
              <li>• JWT аутентификация</li>
              <li>• RESTful API</li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-2 flex items-center">
              <Shield className="mr-2 h-4 w-4" />
              Безопасность
            </h4>
            <ul className="text-sm space-y-1 text-gray-600">
              <li>• RLS политики</li>
              <li>• Шифрование паролей</li>
              <li>• HTTPS/SSL</li>
              <li>• CORS настройки</li>
              <li>• Rate limiting</li>
              <li>• Аудит логи</li>
            </ul>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default TechStackCard;
